import React from 'react';
import type { PictureComponent } from '../../../types/builder';

interface PictureRendererProps {
  component: PictureComponent;
}

export const PictureRenderer: React.FC<PictureRendererProps> = ({ component }) => {
  const { settings } = component;

  const alignmentClass = {
    left: 'justify-start',
    center: 'justify-center',
    right: 'justify-end',
  }[settings.alignment];

  const shadowClass = {
    none: '',
    sm: 'shadow-sm',
    md: 'shadow-md',
    lg: 'shadow-lg',
    xl: 'shadow-xl',
  }[settings.shadow];

  const animationClass = {
    none: '',
    fadeIn: 'animate-fadeIn',
    zoomIn: 'animate-zoomIn',
    slideUp: 'animate-slideUp',
    bounce: 'animate-bounce',
  }[settings.animation];

  const imageElement = (
    <img
      src={settings.src || 'https://placehold.co/1040x1040/1f2937/6b7280?text=1040x1040'}
      alt={settings.alt || 'Picture'}
      style={{
        borderRadius: `${settings.borderRadius}px`,
        maxWidth: '100%',
        width: '100%',
        aspectRatio: '1/1',
        objectFit: 'cover',
      }}
      className={`${shadowClass} ${animationClass}`}
    />
  );

  const content = settings.link ? (
    <a
      href={settings.link}
      target={settings.openInNewTab ? '_blank' : '_self'}
      rel={settings.openInNewTab ? 'noopener noreferrer' : undefined}
      className="block transition-transform hover:scale-[1.02]"
    >
      {imageElement}
    </a>
  ) : (
    imageElement
  );

  return (
    <div 
      className={`flex ${alignmentClass}`}
      style={{ padding: `${settings.padding}px` }}
    >
      <div style={{ maxWidth: '1040px', width: '100%' }}>
        {content}
      </div>
      
      {/* Animation keyframes */}
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes zoomIn {
          from { opacity: 0; transform: scale(0.9); }
          to { opacity: 1; transform: scale(1); }
        }
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fadeIn { animation: fadeIn 0.5s ease-out; }
        .animate-zoomIn { animation: zoomIn 0.5s ease-out; }
        .animate-slideUp { animation: slideUp 0.5s ease-out; }
      `}</style>
    </div>
  );
};















